import { RootState } from '@store';
import { createSelector } from 'reselect';
import { FullAppState, initState } from '@store/reducers/fullApp.reducer';
const fullAppSlice = (state: RootState) => state?.fullApp || initState;

export const selectHasFullAppFlow = createSelector([fullAppSlice], (slice: FullAppState): boolean => slice.hasFullAppFlow);
export const selectIsShowFullAppExitModal = createSelector([fullAppSlice], (slice: FullAppState): boolean => slice.isShowFullAppExitModal);
